<template>
  <div id="bangding_info" class="Transactions_contrnt">
    <HeadBack :title="history ? '历史开户信息' : '绑定开户信息'">
      <el-button @click="bang" class="daochu" size="mini" type="primary" slot="btn" style="position:absolute;right:5px;top:6px;" v-if="!history">绑定线下账户</el-button>
    </HeadBack>
    <el-table :data="clientBinds" style="width: 100%;margin-top:42px;" row-key="id" :expand-row-keys="entexpands" border @row-click="rowExpand" :row-class-name="tableRowClassName">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand pd">
            <div v-if="props.row.status === 0">
              <el-row>
                <!-- <el-col>
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item label="绑定时间：">
                      <span>{{ props.row.bindDate }}</span>
                    </el-form-item>
                    <el-form-item label="绑定状态：">
                      <span>{{ props.row.approvalStatus | changeStatus }}</span>
                    </el-form-item>
                  </el-form>
                </el-col> -->
                <p style="margin-bottom: 5px;">
                  <span style="margin-right: 10px;">绑定时间：</span>
                  <span>{{ timestampToTime(props.row.bindDate) }}</span>
                </p>
                <p style="margin-bottom: 5px;">
                  <span style="margin-right: 10px;">绑定状态：</span>
                  <span>{{ props.row.approvalStatus  | changeStatus }}</span>
                </p>
              </el-row>
              <div v-if="!history && props.row.approvalStatus === '1'">
                <el-row style="margin-bottom:10px">
                  <p>
                    <el-button @click="updateClientBindPassword(props.row.id, props.row.documentType)" size="mini" type="primary">修改交易密码</el-button>
                  </p>
                </el-row>
                <el-row style="margin-bottom:10px">
                  <p>
                    <el-button @click="resetClientBindPassword(props.row.id)" size="mini" type="primary">忘记交易密码</el-button>
                  </p>
                </el-row>
                <el-row style="margin-bottom:10px">
                  <p>
                    <el-button @click="gotoSub(props.row.id)" size="mini" type="primary" :disabled="!(props.row.approvalStatus == 1)">开通业务信息</el-button>
                  </p>
                </el-row>
                <el-row style="margin-bottom:10px">
                  <p>
                    <el-button @click="editClientBindEmail(props.row.id)" size="mini" type="primary">
                      编辑邮箱信息</el-button>
                  </p>
                </el-row>
                <el-row style="margin-bottom:10px">
                  <el-button @click="setDefault(props.row.id)" size="mini" type="primary">将该账户设置为默认账户
                  </el-button>
                </el-row>
                <el-row>
                  <el-button @click="DelClientBindPassword(props.row.id)" size="mini" type="primary">删除</el-button>
                </el-row>
              </div>
              <div v-if="!history && props.row.approvalStatus === '-1'">
                <el-button @click="anewBang(props.row)" size="mini" type="primary">重新绑定</el-button>
                <el-button @click="DelClientBindPassword(props.row.id)" size="mini" type="primary" style="margin-left: 10px;">删除</el-button>
              </div>
              
            </div>
            <div v-if="props.row.status !== 0">
              <p style="margin-bottom: 5px;">
                <span style="margin-right: 10px;">更新时间：</span>
                <span>{{ props.row.updateTime }}</span>
              </p>
              <p style="margin-bottom: 5px;">
                <span style="margin-right: 10px;">绑定状态：</span>
                <span>{{ props.row.status | accountStatus }}</span>
              </p>
              <p style="margin-bottom: 5px;">
                <span style="margin-right: 10px;">描述信息：</span>
                <span>{{ props.row.description }}</span>
              </p>
              <p v-if="!history">
                <el-button @click="anewBang(props.row)" size="mini" type="primary">重新绑定</el-button>
              </p>
            </div>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="线下账户编号" prop="clientNoInner">
      </el-table-column>
      <el-table-column label="公司名称" prop="companyNameInner">
      </el-table-column>
      <el-table-column label="授权人" prop="clientNameInner">
      </el-table-column>
    </el-table>
    <!-- 删除绑定信息 -->
    <el-dialog :close-on-click-modal="false" title="删除绑定信息" :visible.sync="BindDialog" width="90%" center>
      <el-input v-model="BindDialogPaw" placeholder="交易密码" type="password" size="small"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BindDialog = false">取 消</el-button>
        <el-button type="primary" @click="BindDialogBtn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import HeadBack from '../components/HeadBack.vue'
  import axios from '../axios'
  export default {
    name: "bangDing",
    data() {
      return {
        clientBinds: [],
        BindDialog: false,
        BindDialogPaw: '',
        entexpands: [],

        history: 0,
      }
    },
    created() {
      this.getData()
      this.getParams()
    },
    methods: {
      getData() {
        axios.post('clientbind/queryAll.do').then(res => {
          if(!res) {
            this.clientBinds = []
          }
          if (res.data.success) {
            if(this.history) {
              this.clientBinds = res.data.clientBinds;
            } else {
              let data = res.data.clientBinds;
              data = data.filter(item => item.status === 0)
              this.clientBinds = data
            }
          }
        })
      },
      bang() {
        this.$router.push('/bang')
      },
      updateClientBindPassword(id, documentType) {
        this.$store.commit('changebdID', id)
        // this.$router.push('/changePass')
        this.$router.push({
          name: 'changePass',
          path: '/changePass',
          params: {
            documentType,
          }
        })
      },
      resetClientBindPassword(id) {
        this.$store.commit('changebdID', id)
        this.$router.push('/resetDealPass')
      },
      gotoSub(id){
        this.$store.commit('changebdID', id)
        this.$router.push('/subAccount')
      },
      editClientBindEmail(id) {
        this.$store.commit('changebdID', id)
        this.$router.push('/changeEmail')
      },
      DelClientBindPassword(id) {
        this.$store.commit('changebdID', id)
        this.BindDialog = true
      },
      anewBang(row) {
        this.$router.push({
          name: 'bang',
          params: {
            currentRow: row,
          }
        })
      },
      BindDialogBtn() {
        if (this.BindDialogPaw == "") {
          this.$Message.warning('请输入交易密码');
          return false;
        }
        axios.post('clientbind/deleteClientBindById.do', this.qs.stringify({
          clientBindId: this.bdID,
          tradePassword: this.BindDialogPaw
        })).then(res => {      
          if(res) {
            this.$Message.warning('删除成功');
            this.getData()
          }
          this.BindDialogPaw = ''
          this.BindDialog = false

        })
      },
      setDefault(id){
        this.$store.commit('changebdID', id)
        axios.post('clientbind/checkedClientBind.do',this.qs.stringify({
          clientBindId:this.bdID
        })).then(res => {
          if(res) {
            this.$Message.success("设置成功")
          }
        })
      },
      // 将点击箭头显示事件注册为点击整行显示
      rowExpand(row, event, column) {
        Array.prototype.remove = function (val) {
          let index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        if (this.entexpands.indexOf(row.id) < 0) {
          this.entexpands = [];
          this.entexpands.push(row.id);
        } else {
          this.entexpands.remove(row.id);
        }
      },
      tableRowClassName({row, rowIndex}) {
        if(row.status !== 0) {
          return 'warning'
        } else if(row.approvalStatus === '1') {
          return 'success'
        } else if(row.approvalStatus === '-1') {
          return 'failing'
        }
      },
      getParams() {
        this.history = this.$route.params.history
      },
    },
    components: {
      HeadBack
    },
    computed: {
      userID() {
        return this.$store.state.userID
      },
      bdID() {
        return this.$store.state.bdID
      }
    },
    filters: {
      changeStatus(val) {
        if (val == 1) {
          return "绑定成功"
        }
        if (val == 0) {
          return "绑定待审核"
        }
        if (val == -1) {
          return "绑定失败"
        }
      },
      accountStatus(val) {
        if (val == 0) {
          return "正常"
        }
        if (val == -1) {
          return "客户删除"
        }
        if (val == -2) {
          return "后台强制解绑"
        }
        if (val == -3) {
          return "无效(审核失败)"
        }
      }
    },
    watch:{
      $route(to ,from) {
        if(to.name == "bangDing") {
          this.getData()
          this.getParams()
        }
      }
    }
  }

</script>

<style>
.pd {
  padding: 0 20px;
}
.warning {
  background: #999 !important;
}
.success {
  background: #acf2c6 !important;
}
.failing {
  background: #f2f5c5 !important;
}
</style>
